import DatabaseModel from './DatabaseModelOffline.js';

var Configuracion = Object.create(DatabaseModel);

Configuracion.model = 'configuraciones';

export default Configuracion;